import React from 'react';
import { MessageCircle, Mail, MapPin } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../translations/translations';
import { getWhatsAppLink } from '../utils/whatsappHelper';
import './Footer.css';

const Footer = () => {
  const { language } = useLanguage();
  const currentYear = new Date().getFullYear();
  
  const t = translations[language];
  const whatsappLink = getWhatsAppLink(language);

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-main">
          <div className="footer-brand">
            <img src="/rc7-logo-footer-white.png" alt="RC7 Innovation" className="footer-logo-image" />
            <p className="body-small footer-tagline">
              {t.footer.tagline}
            </p>
          </div>

          <div className="footer-contact">
            <h3 className="heading-3 footer-title">{t.footer.contactTitle}</h3>
            <div className="footer-links">
              <a 
                href={whatsappLink} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="footer-link"
              >
                <MessageCircle size={18} />
                <span>+56 9 7557 8118</span>
              </a>
              <a 
                href="mailto:r.cruz.innova@gmail.com" 
                className="footer-link"
              >
                <Mail size={18} />
                <span>r.cruz.innova@gmail.com</span>
              </a>
              <div className="footer-link">
                <MapPin size={18} />
                <span>{t.footer.location}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="body-small footer-copy">
            © {currentYear} {t.footer.copyright}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
